module.exports = __webpack_public_path__ + "img/107028.4d301718.png";